import React, { PropTypes, PureComponent } from 'react';

import classNames from 'classnames';

class LegendItemColor extends PureComponent {
  render() {
    const scaleIconClass = classNames(
      'icon_tiny mt-legend-item-icon text--blue-dark',
      this.props.scale_icon,
    );

    return (<div>
      {this.props.rangesCount > 1 ?
        <div className={scaleIconClass}></div>
      : null}
      <div className="mt-legend-item-color">
        <div style={{ background: this.props.color }}></div>
      </div>
    </div>);
  }
}

LegendItemColor.defaultProps = {
  scale_icon: '',
  color: 'transparent',
  rangesCount: 0,
};

LegendItemColor.propTypes = {
  scale_icon: PropTypes.string,
  color: PropTypes.string,
  rangesCount: PropTypes.number,
};

export default LegendItemColor;



/** WEBPACK FOOTER **
 ** ./apps/maptool/components/Legend/LegendItemColor.js
 **/